// extracted by mini-css-extract-plugin
export default {"drawer":"Drawers_drawer__gowqi","title":"Drawers_title__iGXnr","description":"Drawers_description__-SOJo"};